import { DvToolbarAction } from '@devinco/ui/grid';
import { inject, Injectable } from '@angular/core';
import { ColumnType } from '@features/vt-grid/grid-options/column-types';
import { getStandardActionPreset } from '@features/vt-grid/presets/preset-actions';
import { ToolbarActionsService } from '@features/vt-grid/services/toolbar-actions.service';
import { DeviceDto } from '@shared/interfaces/device';
import { ColDef } from 'ag-grid-community';

@Injectable({ providedIn: 'root' })
export class UserDevicesGridService {
  private toolbarActionService = inject(ToolbarActionsService);

  getColDefs = (): ColDef<DeviceDto>[] => [
    { field: 'DeviceID', hide: true, type: [ColumnType.Id] },
    {
      field: 'DeviceType',
      headerName: 'UserDevice.DeviceType',
      type: [ColumnType.Text],
      flex: 1,
    },
    {
      field: 'DeviceOSVersion',
      headerName: 'UserDevice.DeviceOSVersion',
      type: [ColumnType.Text],
      flex: 1,
    },
    {
      field: 'SoftwarePlatform',
      headerName: 'UserDevice.SoftwarePlatform',
      type: [ColumnType.Text],
      flex: 1,
    },
    {
      field: 'SoftwareVersion',
      headerName: 'UserDevice.SoftwareVersion',
      type: [ColumnType.Text],
      flex: 1,
    },
    {
      field: 'LastLogin',
      headerName: 'UserDevice.LastLogin',
      type: [ColumnType.DateTime],
      flex: 1,
    },
  ];

  getGridActions(editEnabled: boolean): DvToolbarAction<DeviceDto>[] {
    const { deleteSelectedRow } = this.toolbarActionService;
    return [
      ...getStandardActionPreset(),
      {},
      {
        icon: 'delete',
        clickFn: deleteSelectedRow,
        disabled: !editEnabled,
        tooltipKey: 'Grid.Delete',
      },
    ];
  }
}
